import { fetchBonus } from '@ms/api/marketing'
import { useState } from '@ms/utils/useState'

const parseBonusRatio = (data = {}) => {
  const { bonusRatios } = data.entityList[0]
  return bonusRatios.filter((x) => x.ratio > 0).sort((a, b) => a.qualifyingSelections - b.qualifyingSelections)
}

/**
 * 获取有效 bonus 配置
 * @param {String|undefined} planName 为空的时候查realsport bonus，传virtual时查虚拟体育
 * @returns {}
 */
export const fetchBonusConfig = async (planName = undefined) => {
  const { error, data } = await fetchBonus(planName)
  if (error) return Promise.reject(error)
  const { qualifyingOddsLimit } = data.entityList[0]
  const config = {
    createTime: Date.now(),
    qualifyingOddsLimit: qualifyingOddsLimit / 10000,
    bonusRatios: parseBonusRatio(data)
  }
  return config
}

// 解析 bonus 对象
export const getBonusMap = (bonusList = []) => {
  return bonusList.reduce((res, cur) => {
    // 后台返回的值 *10000 了，为保证计算精度，暂时不除 100, 注意其他地方计算的话，需要除 100
    res[cur.qualifyingSelections] = cur.ratio / 100
    return res
  }, {})
}

export default function useBonus(planName = '') {
  let cacheKey = 'config-bonus'
  if (planName) {
    cacheKey = `${cacheKey}-${planName}`
  }

  const fetchData = async () => {
    const res = await fetchBonus(planName)
    const { error, data } = res
    if (error) {
      return res
    }
    return { data: parseBonusRatio(data) }
  }

  const { state: bonusList, loading, request: getBonusConfig } = useState([], { cacheKey, fetchData })

  return {
    bonusList,
    loading,
    getBonusConfig
  }
}
